import { useTranslation } from 'react-i18next';
import Icon from '@cx-web/components/primitives/icon';

import { type CategoryGroup, categoryGroups } from '@cx-modules/constants';

import { useBetslipContext } from '~/providers/betslip-context';

import type IBet from '../interfaces/IBet';
import styles from '../style/bet.module.css';

const Bet = ({ bet, disabled }: {bet: IBet;disabled: boolean;}): JSX.Element => {
  const { getBetMeta, removeBetFromBetslip } = useBetslipContext();
  const { betId, betName, marketName, spread, subeventName } = getBetMeta(bet);

  const { categoryGroupName } = bet;

  const { translationFile } = categoryGroups.find((cg) => cg.name === categoryGroupName) as CategoryGroup || '';

  const ns = [translationFile, 'label', 'bettype'];
  const { t } = useTranslation(ns);

  function extractTeamsFromSubeventName(subeventName: string) {
    const teamSeparators = [' v ', ' at '];

    for (const separator of teamSeparators) {
      const teams = subeventName.split(separator);
      if (teams.length === 2) {
        const [first, second] = teams.map((team) => team.trim());
        return separator === ' v ' ?
        { away: second, first, home: first, second, separator, success: true } :
        { away: first, first, home: second, second, separator, success: true };
      }
    }
    return {
      away: '',
      first: '',
      home: '',
      second: '',
      separator: '',
      success: false
    };
  }

  const translatedRegionalisedSubeventName = () => {
    if (!subeventName) return '';

    const { first, second, separator, success } = extractTeamsFromSubeventName(subeventName);

    if (success) return `${t(first)}${t(separator, { ns: 'label' })}${t(second)}`;
    return t(subeventName);
  };

  const BET_NAME = t(betName);
  const MARKET_NAME = t(marketName, { ns: 'bettype' });

  return (
    <div className={[styles.betWrapper, disabled ? styles.disabled : ''].join(' ')}>
      <div>
        <span className={styles.name}>{BET_NAME}</span>
        {spread && <span className={styles.spreadValue}>{spread}</span>}
        <div className={styles.subeventName}>{translatedRegionalisedSubeventName()}</div>
        <div className={styles.marketName}>{MARKET_NAME}</div>
      </div>
      <span
        className={styles.closeBet}
        data-testid="betslip-close"
        onClick={() => removeBetFromBetslip(betId, disabled, bet)}>

        <Icon height={32} icon="Close" width={32} />
      </span>
    </div>);

};

export default Bet;